import React from 'react'
import { Modal } from 'react-bootstrap'
import CustomButton from '../../CustomButton'

const ModalDeletePreset = (props) => {
	const { name, deletePreset, closeModal } = props;

	return (
		<Modal
			show
			onHide={closeModal}
		>
			<Modal.Header closeButton>
				<Modal.Title className="title">Delete Columns Preset</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text">
					Delete column preset "{name}"?
				</div>
			</Modal.Body>
			<Modal.Footer className="default-modal-footer modal-footer">
				<CustomButton variant="primary" onClick={closeModal}>Cancel</CustomButton >
				<CustomButton variant="delete-outline" onClick={deletePreset}>Delete</CustomButton >
			</Modal.Footer>
		</Modal>
	)
}

export default ModalDeletePreset;
